"use client";

import React from "react";
import Image from "next/image";
import { Box, styled } from "@mui/material";
import { AdConfig } from "@/app/layout/useAdManager";

interface AdModuleProps {
  config: AdConfig;
}

const AdElement = styled(Box, {
  shouldForwardProp: (prop) => {
    return prop !== "isSelected";
  },
})<AdModuleProps>(({ theme, config }) =>
  theme.unstable_sx({
    textAlign: "center",
    backgroundColor: config.noBackground ? "transparent" : "grey.100",
    img: {
      maxWidth: "100%",
      height: "auto",
    },
    minWidth: config.width + "px",
    minHeight: config.height + "px",
  })
);

const AdContainer = styled(Box, {
  shouldForwardProp: (prop) => {
    return prop !== "isSelected";
  },
})<AdModuleProps>(({ theme, config }) =>
  theme.unstable_sx({
    backgroundColor: config.noBackground ? "transparent" : "grey.100",
    padding: config?.noPadding ? 0 : 2,
    ...(config.minWidth
      ? {
          [`@media (max-width: ${config.minWidth}px)`]: {
            display: "none",
          },
        }
      : {}),
  })
);

function AdModule({ config }: { config: AdConfig }) {
  return (
    <AdContainer config={config}>
      <AdElement config={config} id={config.elementId}>
        {config.static && (
          <a href={config.static.url} target="_blank" rel="noopener noreferrer">
            <Image
              src={config.static.image}
              width={config.width}
              height={config.height}
              alt={config.static.alt}
            />
          </a>
        )}
      </AdElement>
    </AdContainer>
  );
}

export default AdModule;
